module.exports = __webpack_public_path__ + "img/home-banner2.a847aa53.jpg";